import { ReactNode } from 'react';

import type { ColorScheme, DisplayMode } from '../Chatbot';

interface ChatModalProps {
  isVisible: boolean;
  onHide?: () => void;
  displayMode: DisplayMode;
  headerActions?: ReactNode;
  children: ReactNode;
  inline?: boolean;
  colorScheme: ColorScheme;
}

export function ChatModal({
  isVisible,
  onHide,
  displayMode,
  headerActions,
  children,
  inline,
  colorScheme,
}: ChatModalProps) {
  let className = 'jr-ai-assist jr-ai-assist-modal-wrapper';

  const mode = inline ? 'inline' : isVisible ? displayMode : null;
  if (mode) className += ` jr-ai-assist-${mode}`;

  const wrapperClassName =
    colorScheme === 'system' ? '' : `jr-color-scheme-${colorScheme}`;

  return (
    <div className={wrapperClassName}>
      <div className={className}>
        <div className="jr-ai-assist-modal-backdrop" onClick={onHide} />
        <div className="jr-ai-assist-modal">
          <div className="jr-ai-assist-modal-header">
            <div className="jr-ai-assist-modal-title">
              <span className="headline" />

              {headerActions}

              <button
                className="jr-ai-assist-button ghost"
                type="button"
                onClick={hideChatbot}
              >
                <i className="jr-ai-icon jr-ai-icon-cross" />
              </button>
            </div>
          </div>

          {children}
        </div>
      </div>
    </div>
  );

  function hideChatbot(e: React.MouseEvent) {
    e.stopPropagation();
    onHide?.();
  }
}
